import { ChangePlanButtonMutation$data } from '__generated__/ChangePlanButtonMutation.graphql';

export enum ViewState {
  ManageAccount = 'MANAGE_ACCOUNT',
  ManageLines = 'MANAGE_LINE',
}

interface ChangePlanRedirect {
  path: string;
  planId: string;
}

export interface UserInfoUpdateType {
  accounts?: ChangePlanButtonMutation$data['updateMobileChangePlanUser']['accounts'];
  eligibleLines?: ChangePlanButtonMutation$data['updateMobileChangePlanUser']['eligibleLines'];
  selectedAccount?: string;
  redirect?: ChangePlanRedirect | null;
}
